// header.js
// Update the MenuDrawer class in header.js

class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.drawer = this.querySelector('#menu-drawer');
    this.toggleButtons = document.querySelectorAll('[data-action="toggle-menu-drawer"]');
    this.closeButton = this.querySelector('#menu-drawer-close');
    this.overlay = document.querySelector('.header-drawer-overlay');
    this.header = document.querySelector('.shopify-section-header');
    this.init();
  }

  init() {
    if (!this.drawer) return;
    
    // Setup event listeners for toggle buttons
    if (this.toggleButtons.length) {
      this.toggleButtons.forEach(button => {
        button.addEventListener('click', this.handleToggle.bind(this));
      });
    }

    // Setup close button event listener
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.handleClose.bind(this));
    }

    // Setup overlay click to close
    if (this.overlay) {
      this.overlay.addEventListener('click', this.handleClose.bind(this));
    }

    // Handle ESC key to close drawer
    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape' && this.isOpen()) {
        this.handleClose();
      }
    });

    // Prevent body scroll when drawer is open
    this.drawer.addEventListener('transitionend', () => {
      if (this.isOpen()) {
        document.body.classList.add('overflow-hidden');
      }
    });
  }

  isOpen() {
    return this.drawer.classList.contains('active');
  }

  handleToggle(event) {
    event.preventDefault();
    if (this.isOpen()) {
      this.handleClose();
    } else {
      this.handleOpen();
    }
  }

  handleOpen() {
    // Position the drawer at the current header position
    this.positionDrawer();
    
    this.drawer.classList.add('active');
    this.overlay.classList.add('active');
    document.body.classList.add('overflow-hidden');
    this.drawer.setAttribute('aria-hidden', 'false');
  }

handleClose() {
    this.drawer.classList.remove('active');
    this.overlay.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    this.drawer.setAttribute('aria-hidden', 'true');

    // NEW FIX: Close the native <details> as well
    const details = this.closest('details');
    if (details) {
      details.removeAttribute('open');
    }
}
  // New method to position the drawer at the current header position
  positionDrawer() {
    if (!this.header || !this.drawer) return;
    
    // Get the current vertical position of the header
    const headerRect = this.header.getBoundingClientRect();
    const headerTop = headerRect.top;
    const headerHeight = headerRect.height;
    
    // Set the drawer's top position to match the header
    this.drawer.style.top = `${headerTop}px`;
    
    // Adjust the drawer's inner container padding to account for header height
    const innerContainer = this.drawer.querySelector('.menu-drawer__inner-container');
    if (innerContainer) {
      innerContainer.style.paddingTop = `${headerHeight}px`;
    }
  }
}

// For the StickyHeader class, make sure it's properly observing header position
// Add this to your StickyHeader class methods to manage drawer positioning
// inside the connectedCallback method after other initializations:
/* 
  this.menuDrawer = document.querySelector('menu-drawer');
  
  // Update drawer position when header reveals/hides
  window.addEventListener('scroll', () => {
    if (this.menuDrawer && this.menuDrawer.isOpen && typeof this.menuDrawer.positionDrawer === 'function') {
      this.menuDrawer.positionDrawer();
    }
  }, { passive: true });
*/

class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.shopify-section-header');
    this.headerWrapper = document.querySelector('.header-wrapper');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');
    this.colorScheme = document.querySelector('main')?.querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme') || "";
    this.isLightLogo = document.querySelector('main')?.querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-light-logo') || "";
    this.menuDrawers = document.querySelectorAll('menu-drawer');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();

    if (this.isLightLogo == 'true')
      this.header.classList.add('header--light-logo');
    else 
      this.header.classList.remove('header--light-logo');
  }

  disableScroll() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  enableScroll() {
    window.addEventListener('scroll', this.onScrollHandler, false);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    if (this.header) {
      observer.observe(this.header);
    }
  }

  onScroll() {
    // Don't handle scroll events when menu drawer is open
    if (this.isAnyMenuDrawerOpen()) {
      return;
    }

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.colorScheme = document.querySelector('main')?.querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme');
    
    if (this.headerIsAlwaysSticky) {
      if (this.header.classList.contains("color-background-overlay")) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.remove('color-background-overlay');
          this.header.classList.forEach(className => {
            if (className.startsWith('color-background-') && className != 'color-background-overlay') {
              this.header.classList.remove(className);
            }
          });
          this.header.classList.add('shopify-section-header-scroll');
          this.header.classList.add('color-background-overlay-hidden');
        };
      };

      if (this.header.classList.contains('color-background-overlay-hidden')) {
        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.add('color-background-overlay');
          if (this.colorScheme)
            this.header.classList.add(this.colorScheme);  
          this.header.classList.remove('shopify-section-header-scroll');
          this.header.classList.remove('color-background-overlay-hidden');
        };
      };
    }

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  isAnyMenuDrawerOpen() {
    if (!this.menuDrawers.length) return false;
    
    for (let i = 0; i < this.menuDrawers.length; i++) {
      if (this.menuDrawers[i].querySelector('#menu-drawer')?.classList.contains('active')) {
        return true;
      }
    }
    return false;
  }

  hide() {
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-scroll');
      return;
    }
    // Don't hide the header if a menu drawer is open
    if (this.isAnyMenuDrawerOpen()) return;
    
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-scroll');
      return;
    }
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');

    if (this.header.classList.contains('color-background-overlay')) {
      this.header.classList.remove('color-background-overlay');
      this.header.classList.forEach(className => {
        if (className.startsWith('color-background-') && className != 'color-background-overlay') {
          this.header.classList.remove(className);
        }
      });
      this.header.classList.add('color-background-overlay-hidden');
    }
  }

  reset() {
    this.colorScheme = document.querySelector('main')?.querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme');
    if (this.headerIsAlwaysSticky) {
      this.header.classList.remove('shopify-section-header-scroll');
      return;
    }
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

    if (this.header.classList.contains('color-background-overlay-hidden')) {
      this.header.classList.add('color-background-overlay');
      if (this.colorScheme)
        this.header.classList.add(this.colorScheme);
      this.header.classList.remove('color-background-overlay-hidden');
    }
  }

  closeMenuDisclosure() {
    // Skip closing menu disclosures if any menu drawer is open
    if (this.isAnyMenuDrawerOpen()) return;
    
    this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
    if (typeof DetailsDisclosure !== 'undefined') {
      this.disclosures.forEach((disclosure) => {
        // Skip if this is part of the menu drawer
        if (disclosure.closest('#menu-drawer')) {
          return;
        }
        disclosure.close();
      });
    }
    
    this.disclosureLists = this.header.querySelectorAll('.disclosure__list:not(.menu-drawer .disclosure__list)');
    this.disclosureLists.forEach((disclosureList) => {
      disclosureList.setAttribute('hidden', true); 
    });
  }
}

// Load components when the DOM is ready
if (typeof customElements !== 'undefined') {
  customElements.define('menu-drawer', MenuDrawer);
  customElements.define('sticky-header', StickyHeader);
}

// Add any existing global event listeners
document.addEventListener('DOMContentLoaded', () => {
  // Ensure the drawer toggle buttons work regardless of scroll position
  const toggleButtons = document.querySelectorAll('[data-action="toggle-menu-drawer"]');
  const drawer = document.getElementById('menu-drawer');
  const overlay = document.querySelector('.header-drawer-overlay');
  
  if (!drawer || !toggleButtons.length) return;
  
  // Handle z-index for sticky header
  const header = document.querySelector('.shopify-section-header');
  if (header) {
    // Ensure the drawer has proper z-index
    drawer.style.zIndex = '1001';
    overlay.style.zIndex = '1000';
  }
});